module.exports = __webpack_public_path__ + "static/media/read_content_aloud_bhojpuri.816d2851.mp3";